export const FHIRQueryResourceParamType_Mandatory = 'mandatory';
export const FHIRQueryResourceParamType_Dynamic = 'dynamic';
export const FHIRQueryResourceParamType_Optional = 'optional';
//# sourceMappingURL=types.js.map